import React from 'react';
import { useParams } from 'react-router-dom';
import { mockMutualFunds } from '../../utils/mockMutualFunds';
import styles from './CollectionPage.module.css';
import { Link } from 'react-router-dom';

const CollectionPage = () => {
  const { collectionName } = useParams();
  const getInitials = (name) => (name ? name.charAt(0).toUpperCase() : '');

  const getFilteredFunds = () => {
    switch (collectionName) {
      case 'high-return':
        return mockMutualFunds.filter(fund => fund.returns['3Y'] > 30);
      case 'gold-funds':
        return mockMutualFunds.filter(fund => fund.category.toLowerCase().includes('gold'));
      default:
        return [];
    }
  };

  const filteredFunds = getFilteredFunds();

  const getTitle = () => {
    switch (collectionName) {
      case 'high-return':
        return 'High Return Funds';
      case 'gold-funds':
        return 'Gold Funds';
      default:
        return 'Collection';
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>{getTitle()}</h1>
        <p>{filteredFunds.length} funds</p>
      </div>
      <div className={styles.list}>
        {filteredFunds.map(fund => (
          <Link to={`/mutual-funds/invest/${fund.id}`} className={styles.row} key={fund.id}>
            <div className={styles.fundInfo}>
              <div className={styles['fund-initials']}>{getInitials(fund.name)}</div>
              <div>
                <p className={styles.fundName}>{fund.name}</p>
                <p className={styles.fundCategory}>{fund.category} &middot; {fund.rating} &#9733;</p>
              </div>
            </div>
            <div className={styles.fundReturns}>
              <p className={styles.returns}>{fund.returns['3Y'] ? `${fund.returns['3Y']}%` : 'NA'}</p>
              <p className={styles.returnsLabel}>3Y</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CollectionPage;
